import * as React from "react";

import { cn } from "@/lib/utils";
import { BORDER_OPACITY, BORDER_RADIUS } from "./constants";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
	({ className, ...props }, ref) => {
		return (
			<textarea
				className={cn(
					"flex min-h-24 w-full border focus-visible:outline-0 bg-background px-3 py-2 text-sm placeholder:text-[#D9D9D9] disabled:cursor-not-allowed disabled:opacity-5 transition-colors",
					BORDER_RADIUS.md,
					BORDER_OPACITY.standard,
					"focus:border-focus",
					className,
				)}
				ref={ref}
				{...props}
			/>
		);
	},
);
Textarea.displayName = "Textarea";

export { Textarea };
